/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Reason_OtherInputs */

const en_sorx_reason_other = /** @type {(inputs: Sorx_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`another reason`)
};

const id_sorx_reason_other = /** @type {(inputs: Sorx_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alasan lain`)
};

/**
* | output |
* | --- |
* | "another reason" |
*
* @param {Sorx_Reason_OtherInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_reason_other = /** @type {((inputs?: Sorx_Reason_OtherInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Reason_OtherInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_reason_other(inputs)
	return en_sorx_reason_other(inputs)
});